const LOGIN_EXPIRED_RESULT = 101132
const THIRD_PAY_TOKEN_CACHE_KEY = 'fromThirdPayTokenCache'
const THIRD_PAY_TOKEN_CACHE_TIME = 60 * 60 * 1000

const isThirdPayLoginExpired = (response = {}) => {
    return Number(response.result) === LOGIN_EXPIRED_RESULT
}

const getThirdPayToken = (response = {}) => {
    const data = response.data || {}
    const list = data.list || {}

    return data.token || list.token || response.token || ''
}

const shouldUseThirdPayChannelToken = (siteName = '') => {
    return siteName === 'qtpay'
}

const getDefaultStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.localStorage
}

const clearThirdPayTokenCache = (storage = getDefaultStorage()) => {
    if (!storage) {
        return
    }

    storage.removeItem(THIRD_PAY_TOKEN_CACHE_KEY)
}

const getThirdPayTokenCacheInfo = (storage = getDefaultStorage(), titck = '', now = Date.now()) => {
    if (!storage || !titck) {
        return null
    }

    try {
        const cache = JSON.parse(storage.getItem(THIRD_PAY_TOKEN_CACHE_KEY) || '{}')

        if (!cache.token || cache.titck !== titck) {
            clearThirdPayTokenCache(storage)
            return null
        }

        if (Number(cache.expiresAt) <= now) {
            clearThirdPayTokenCache(storage)
            return null
        }

        return cache
    } catch (error) {
        clearThirdPayTokenCache(storage)
        return null
    }
}

const getThirdPayTokenCache = (storage = getDefaultStorage(), titck = '', now = Date.now()) => {
    const cache = getThirdPayTokenCacheInfo(storage, titck, now)

    if (!cache) {
        return ''
    }

    return cache.token
}

const setThirdPayTokenCache = (storage = getDefaultStorage(), titck = '', token = '', now = Date.now(), channelName = '') => {
    if (!storage || !titck || !token) {
        return 0
    }

    const expiresAt = now + THIRD_PAY_TOKEN_CACHE_TIME
    const cache = {
        titck,
        token,
        expiresAt
    }

    if (channelName) {
        cache.channelName = channelName
    }

    storage.setItem(THIRD_PAY_TOKEN_CACHE_KEY, JSON.stringify(cache))

    return expiresAt
}

module.exports = {
    clearThirdPayTokenCache,
    getThirdPayToken,
    getThirdPayTokenCache,
    getThirdPayTokenCacheInfo,
    setThirdPayTokenCache,
    isThirdPayLoginExpired,
    shouldUseThirdPayChannelToken
}
